// extracted by css-extract-rspack-plugin
export default {"createTeamGroupDescription":"WJxRVAYT4aMaPajc"};